export function getGoalBars(
  totalGreaterThan: number | null,
  formatBars: (val: number | null | undefined) => string,
  barUnit: string | undefined,
  totalLessThan: number | null
): (
  | { mode: "GT"; value: number; label: string }
  | { mode: "LT"; value: number; label: string }
)[] {
  return [
    ...(totalGreaterThan
      ? [
          {
            mode: "GT" as const,
            value: totalGreaterThan,
            label: `${formatBars(totalGreaterThan)}${barUnit ?? ""}`,
          },
        ]
      : []),
    ...(totalLessThan
      ? [
          {
            mode: "LT" as const,
            value: totalLessThan,
            label: `${formatBars(totalLessThan)}${barUnit ?? ""}`,
          },
        ]
      : []),
  ];
}
